let hydrated = false

export const isHydrated = () => hydrated

export const markHydrated = () => {
  hydrated = true
}
